module.exports = __webpack_public_path__ + "img/factoryImageLogo.49f0f841.jpg";